import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { CategoryComponent } from './categories/list/list.component';
import { LoginComponent } from './users/login/login.component';
import { NewCategory } from './categories/new/new.component';
import { MenuComponent } from './dashboard/menu/menu.component';
import { ProductComponent } from './products/list/list.component';
import { NewProduct } from './products/new/new.component';
import { CostComponent } from './costs/view/view.component';
import { IngredientComponent } from './ingredients/list/list.component';
import { NewIngredient } from './ingredients/new/new.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: MenuComponent },
  { path: 'categories', component: CategoryComponent },
  { path: 'category/new', component: NewCategory },
  { path: 'ingredients', component: IngredientComponent },
  { path: 'ingredient/new', component: NewIngredient },
  { path: 'products', component:  ProductComponent },
  { path: 'product/new', component: NewProduct },
  { path: 'costs', component: CostComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    CategoryComponent,
    LoginComponent,
    NewCategory,
    MenuComponent,
    ProductComponent,
    NewProduct,
    CostComponent,
    IngredientComponent,
    NewIngredient,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }